import React, { useCallback } from 'react'
import HtmlEditor, {
    Toolbar,
    MediaResizing,
    ImageUpload,
    Item,
} from 'devextreme-react/html-editor';

interface Props {
    currentText: string
    handleTextChange: (e) => void
}

const TextInputBox: React.FC<Props> = ({ currentText, handleTextChange }) => {


    //const headerValues = ;
    const onValueChangedHandler = useCallback((e) => {
        handleTextChange(e)
    }, [handleTextChange])


    const headerValues = [false, 1, 2, 3, 4, 5]
    return <div>
        <HtmlEditor value={currentText} onValueChanged={onValueChangedHandler} height="600px" >
            <MediaResizing enabled={true} />
            <ImageUpload tabs={['file'] } fileUploadMode="base64" />
            <Toolbar>
                <Item name="separator" />
                <Item name="bold" />
                <Item name="italic" />
                <Item name="strike" />
                <Item name="underline" />
                <Item name="separator" />
                <Item name="alignLeft" />
                <Item name="orderedList" />
                <Item name="bulletList" />
                <Item name="separator" />
                <Item name="color" />
                <Item name="background" />
                <Item name="separator" />
                {/*<Item name="header" acceptedValues={headerValues} />*/}
                <Item name="link" />
                <Item name="image" />
            </Toolbar>
        </HtmlEditor>
    </div>
} 
export default TextInputBox